<template>
  <div>
    <div class="mx-2">
      <h3 class="mt-5">
        {{ $getVisibleNames("mesh.genericcareer", false, "Carrera Genérica") }}
        <AlternativeNameButton
          :table_name="'mesh.genericcareer'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_genericcareer'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.genericcareer',
                  false,
                  'Carrera Genérica'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-generic_career-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="genericCareers"
        :pagination="genericCareers.length"
        :fields="genericCareersFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.genericcareer',
                  false,
                  'Carrera Genérica'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-generic_career-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            :click_button="() => askForDeleteGenericCareer(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.genericcareer',
                  false,
                  'Carrera Genérica'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-generic_career-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.genericcareer',
                  false,
                  'Carrera Genérica'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <GenericCareerForm
              :GenericCareer="row.item"
              @updated="slotUpdatedGenericCareer"
              :show_title="false"
            ></GenericCareerForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-generic_career-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.genericcareer',
            false,
            'Carrera Genérica'
          ),
        })
      "
      size="lg"
    >
      <GenericCareerForm
        @created="slotCreatedGenericCareer"
      ></GenericCareerForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "GenericCareerView",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericCareerForm: () =>
      import(
        "@/components/mesh/CurricularResources/GenericCareer/GenericCareerForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      genericCareers: names.GENERIC_CAREERS,
    }),
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_genericcareer");
      if (has_permission) return has_permission;
      else return false;
    },
    genericCareersFields() {
      if (!this.allows_crud)
        return this.genericCareers_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.genericCareers_fields;
    },
    genericCareers_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.genericcareer",
              true,
              "Carreras Genéricas"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "code",
          label: this.$t("reusable.common.code"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          // sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    askForDeleteGenericCareer(generic_career_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.genericcareer",
            false,
            "Carrera Genérica"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_GENERIC_CAREER, generic_career_id)
            .then(() => {
              toast(
                this.$getVisibleNames(
                  "mesh.genericcareer",
                  false,
                  "Carrera Genérica"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              );
            });
        }
      });
    },
    slotCreatedGenericCareer() {
      this.$bvModal.hide("new-generic_career-modal");
    },
    slotUpdatedGenericCareer(generic_career) {
      this.$bvModal.hide(`edit-generic_career-modal-${generic_career.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_GENERIC_CAREERS);
  },
  created() {},
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-generic_career {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>